import { color } from "../../../value/types/color/index.js";
import { complex } from "../../../value/types/complex/index.js";
import { dimensionValueTypes } from "./dimensions.js";
import { testValueType } from "./test.js";
const valueTypes = [...dimensionValueTypes, color, complex];
const findValueType = (v) => valueTypes.find(testValueType(v));
export {
  findValueType
};
//# sourceMappingURL=find.js.map
